import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=5bb27c44&scoped=true&"
import script from "./formGroup.vue?vue&type=script&lang=js&"
export * from "./formGroup.vue?vue&type=script&lang=js&"
import style0 from "./formGroup.vue?vue&type=style&index=0&id=5bb27c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb27c44",
  null
  
)

export default component.exports